let request = `
const request = require('request');

const options = {
  method: 'POST',
  url: ,
  headers: {},
  body: {},
  json: true
};

request(options, function (error, response, body) {
  if (error) throw new Error(error);

  console.log(body);
});
`

export default (options) => {
    options.json = true
    return request.replace(/{.*};/s, JSON.stringify(options, null, 4))
}